import {BMTheme} from "../../../BMTheme";

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  linkStyle: {
    color: BMTheme.palette.primary1Color,
    display: "flex",
    height: "100%",
    alignItems: "center"
  },

  textFieldStyle: {
    textTransform: "capitalize"
  }
};

export const formStyle = {
  textFieldContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
    marginBottom: 20
  },
  textFieldStyle: {
    paddingRight: 10
  },
  labelFieldStyle: {
    paddingRight: 10,
    textTransform: "uppercase"
  },

  clearDiv: {
    clear: "both"
  },

  containerInput: {
    float: "left",
    marginRight: "2%"
  },

  selectInput: {
    textTransform: "capitalize"
  },

  checkboxStyle: {
    maxWidth: 100,
    marginTop: "2%"
  },

  dateInput: {
    textFieldStyle: {
      height: "72px"
    },
    customInputStyle: {
      paddingTop: 10
    },
    wrapperStyle: {
      display: "flex"
    },
    timeStyle: {
      paddingLeft: "2%"
    }
  },

  arrayInput: {
    innerContainerStyle: {
      padding: 0,
      margin: 0,
      boxSizing: "content-box"
    },
    labelContainerStyle: {
      padding: 0,
      margin: 0,
      marginTop: "1.2em"
    }
  },
  textInput: {
    rowNumberStyle: {
      float: "left",
      color: BMTheme.label.labelGrayColor,
      fontFamily: "Titillium Web",
      width: "1.5em",
      marginRight: "1%",
      paddingTop: "1em"
    },
    outcomeStyle: {
      padding: 0,
      margin: 0,
      float: "left",
      width: "5em",
      height: "1.5em",
      marginRight: "5%",
      paddingBottom: "1.5em"
    },
    teamStyle: {
      padding: 0,
      margin: 0,
      float: "left",
      width: "35%",
      height: "1.5em",
      marginRight: "5%",
      paddingBottom: "1.5em"
    },

    horsesStyle: {
      padding: 0,
      margin: 0,
      float: "left",
      width: "66%",
      height: "1.5em",
      marginRight: "5%",
      paddingBottom: "1.5em"
    },
    reserveStyle: {
      padding: 0,
      margin: 0,
      float: "left",
      width: "10em",
      height: "1.5em",
      marginRight: "5%",
      paddingBottom: "1.5em"
    }
  }
};

export const deleteStyle = {
  deleteText: {
    textTransform: "capitalize"
  },
  slipType: {
    textTransform: "lowercase"
  }
};

export const validationStyle = {
  required: {
    position: "absolute",
    marginTop: 25
  },
  validateBoost: {
    position: "absolute"
  },
  validateOutcome: {
    position: "absolute",
    paddingTop: 15
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/style.js